<template>
  <div>
    <vue-headful title="Sollicitaties" />
    <Header page_title="Sollicitaties" />
    <div class="container-fluid px-0 mb-0">
      <p class="mt-3">
        <job-filter @filter-change="filterChanged" :showAll="false" :subbranch="true" />
      </p>
    </div>
    <div v-if="interested ? interested.length > 0 : false">
      <div class="px-4 mx-2">
        <div class="container-fluid px-0 pb-1 mb-2">
          <p class="mb-3 margin-top-2">
            <strong>{{ interested.length }} Uitnodiging(en)</strong>
          </p>
          <div class="mb-5">
              <template v-if="branch == '3'">
                    <HealthcareInterestedCard
                      v-for="(job, index) in interested"
                      :key="job.job_id"
                      :job="job"
                      :index_key="index"
                      @notification="notifChanged"
                      @job-id-change="jobIdChanged"
                    />
              </template>
              <template v-else>
                  <InterestedCard
                      v-for="(job, index) in interested"
                      :key="job.job_id"
                      :job="job"
                      :index_key="index"
                      @notification="notifChanged"
                      @job-id-change="jobIdChanged"
                  />
              </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="applied ? applied.length > 0 : false">
      <div class="px-4 mx-2">
        <div class="container-fluid px-0 pb-1 mb-2">
          <p class="mb-3 margin-top-2">
            <strong>{{ applied.length }} Sollicitatie(s)</strong>
          </p>
          <div class="mb-5">
              <template v-if="branch == '3'">
                  <JobCardHealthcare
                      v-for="job in applied"
                      :key="job.job_id"
                      :job="job"
                      :job_ids="job_ids"
                      :applied="true"
                  />
              </template>
              <template v-else>
                <JobCard
                  v-for="(job, index) in applied"
                  :key="job.job_id"
                  :job="job"
                  :applied="true"
                />
              </template>
          </div>
        </div>
      </div>
    </div>
    <Empty v-if="!interested && !applied" text="Je hebt nog niet gesolliciteerd en er zijn ook nog geen verzoeken." />
    <Notification
      v-if="fullscreen_notif == 'applied'"
      text="<p>Goed bezig, je sollicitatie is verstuurd!</p>"
      :link="{ name: 'applicant-dashboard' }"
      button="Terug naar mijn dashboard"
      button_style="btn-light"
    />
    <div
      v-if="fullscreen_notif == 'comment'"
      class="fullscreen-notif bg-light position-fixed"
    >
      <button
        type="button"
        class="close position-fixed"
        aria-label="Close"
        v-on:click="fullscreen_notif = null; comment = '';job_id = null, job_key = null; job_percentage = 0"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div>
              <NotificationContainer />
              <div class="form-group">
                <textarea
                  maxlength="160"
                  class="form-control"
                  :placeholder="
                    'Heb je vragen of opmerkingen over deze vacature? \n(Max. 160 tekens)'
                  "
                  rows="4"
                  spellcheck="false"
                  v-model="comment"
                ></textarea>
              </div>
              <a
                class="btn btn-warning btn-block"
                role="button"
                @click="onApplySubmit"
                >Doorgaan</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";
import InterestedCard from "@/components/InterestedCard.vue";
import JobFilter from "@/components/JobFilter.vue";
import JobCardHealthcare from "@/components/JobCardHealthcare.vue";
import HealthcareInterestedCard from "@/components/HealthcareInterestedCard.vue";

export default {
  data: function() {
    return {
      applied: [],
      fullscreen_notif: null,
      interested: null,
      job_id: null,
      job_percentage: 0,
      job_key: null,
      comment: "",
      filterValues: {
        showAll: false,
        maxShown: 20,
        subbranch: ''
      },
        branch: localStorage.getItem('branch'),
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.applied = await this.getTokenAPIList("jobs/applied");
      this.interested = await this.getTokenAPIList("jobs/interested");
      this.$store.state.loading = false;
    },
    async notifChanged () {
      this.fullscreen_notif = "comment"
    },
    async jobIdChanged (id, job_percentage, index_key) {
      this.job_id = id;
      this.job_key = index_key;
      this.job_percentage = job_percentage;
    },
    async onApplySubmit() {
      this.$store.state.loading = true;
      window.scrollTo(0, 0);
      try {
        await this.sendApplication(
          this.job_id,
          this.comment,
          this.job_percentage
        );
        this.fullscreen_notif = "applied";
      } catch (e) {
        this.fullscreen_notif = null;
      }
      this.job_id = null;
      this.job_key = null;
      this.job_percentage = 0;
      this.comment = "";
    },
    async filterChanged(data) {
      this.filterValues = data;
      this.$store.state.loading = true;

      if(this.filterValues.subbranch === '1')
      {
        this.applied = await this.getTokenAPIList('jobs/applied?subbranch=1');
        this.interested = await this.getTokenAPIList("jobs/interested?subbranch=1");
      }
      else if(this.filterValues.subbranch === '2')
      {
        this.applied = await this.getTokenAPIList('jobs/applied?subbranch=2');
        this.interested = await this.getTokenAPIList("jobs/interested?subbranch=2");
      }
      else
      {
        this.applied = await this.getTokenAPIList('jobs/applied');
        this.interested = await this.getTokenAPIList("jobs/interested");
      }

      if(this.applied == null) {this.applied = [];}

      this.$store.state.loading = false;
    }
  },
  components: {
      HealthcareInterestedCard,
      JobCardHealthcare,
    JobFilter,
    JobCard,
    InterestedCard
  }
};
</script>

<style scoped>

::v-deep .component .title {
  padding-right: 30px;
}

.margin-top-2 {
  margin-top: 2rem;
}

</style>
